module.exports = __webpack_public_path__ + "img/symbol-quarter-right.23eb996d.png";